/** srcdoc inherits the parent URL, so bare fragments otherwise reload the app. */
export function previewLinks(html: string) {
  const doc = new DOMParser().parseFromString(html, 'text/html');
  let changed = false;
  for (const link of doc.querySelectorAll('a[href]')) {
    const href = link.getAttribute('href')?.trim();
    if (href?.startsWith('#')) {
      changed = true;
      link.setAttribute('href', `about:srcdoc${href}`);
      link.setAttribute('target', '_self');
    }
  }
  return changed ? `<!doctype html>${doc.documentElement.outerHTML}` : html;
}
